import { CheckIcon } from '../../../components/icons';
import { Dropdown, Text } from '../../../components';
import React from 'react';
import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';

type Props = {
  onSelect?: (item: string) => void;
  onClear?: () => void;
  selected?: string;
  options: string[];
  title: string;
};
export const FilterItem: React.FC<Props> = ({
  onSelect,
  //onClear,
  selected,
  options,
  title,
}) => {
  return (
    <Dropdown.Root
      noShadow
      triggerComponent={
        <div
          className={css`
            border: 1px solid
              ${selected
                ? theme.colors.text['highlight/1']
                : theme.colors.border.primary};
            padding: 4px 4px 4px 8px;
            border-radius: 4px;
            width: fit-content;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          `}
        >
          <Text.Body2XS>{selected || title}</Text.Body2XS>
          {/* selected && (
            <div
              className={css`
                cusor: pointer;
                width: 16px;
                height: 16px;
                margin-left: 12px;
                border: 1px solid red;
              `}
              onClick={(e) => {
                e.stopPropagation();
                onClear?.();
              }}
            >
              <CloseIcon
                style={{
                  width: '12px',
                  height: '12px',
                }}
                fill={theme.colors.text.seconday}
              />
            </div>
          )*/}
        </div>
      }
    >
      {options?.map((option) => (
        <Dropdown.Item key={option}>
          <div
            onClick={() => {
              onSelect?.(option);
            }}
            className={css`
              display: flex;
              flex-direction: row;
              align-items: center;
              padding: 4px 8px;
              cursor: pointer;
            `}
          >
            {option === selected && (
              <CheckIcon
                style={{ marginRight: '6px', width: '16px', height: '16px' }}
                fill={theme.colors.text['highlight/1']}
              />
            )}
            <Text.Body2XS>{option}</Text.Body2XS>
          </div>
        </Dropdown.Item>
      ))}
    </Dropdown.Root>
  );
};
